
































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import GalleryFilters from "@/components/GalleryFilters";
import PageTitle from "@/components/PageTitle";
import { filterItems } from "../../const";
import GalleryFeed from "../GalleryFeed";
import GalleryGrid from "../GalleryGrid";
import ProviderInfo from "../ProviderInfo";

export default defineComponent({
  name: "PurchaseGalleryView",
  components: { ProviderInfo, EmptyContent, GalleryFeed, GalleryGrid, BasePage, GalleryFilters, PageTitle },
  props: {
    itemId: { type: String },
    type: { type: String },
    loading: { type: Boolean, default: false },
    items: { type: Array as PropType<PurchasedItem[]>, required: true },
    totalItems: { type: Number, default: 0 },
    provider: { type: Object as PropType<UserPublicData> },
    enableScroll: { type: Boolean, default: true },
  },
  setup(props, { root }) {
    const isFeedView = computed(() => !!props.itemId);

    const toggleView = () => {
      if (!props.items.length) return;
      if (isFeedView.value) {
        root.$router.replace({ name: "purchaseGallery", query: { type: props.type } });
      } else {
        const id = props.itemId ? props.itemId : props.items[0].id;
        root.$router.push({ name: "purchaseGallery", query: { type: props.type, id } });
      }
    };

    const onGridItemClick = (id: string) => {
      root.$router.push({ name: "purchaseGallery", query: { type: props.type, id } });
    };

    return { filterItems, isFeedView, toggleView, onGridItemClick };
  },
});
